import React, { useState, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

interface ExpandableSectionProps {
    title: string;
    defaultExpanded?: boolean
    children: ReactNode;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({ title, children, defaultExpanded = false }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <div className="expandablesection__container">
            <div className="expandablesection">
                <ul className="expandablesection__ul">
                    <li className="expandablesection__li">
                        <div className="expandablesection-item">
                            <button
                                onClick={() => setIsExpanded(!isExpanded)}
                                aria-expanded={isExpanded}
                            >
                                <div>
                                    <span className="includes__title">{title}</span>
                                </div>
                                <FontAwesomeIcon
                                    className={`icon ${isExpanded ? 'rotate-180' : ''}`}
                                    icon={faAngleDown}
                                    aria-hidden="true"
                                />
                            </button>
                            <div className={`expandablesection-content ${isExpanded ? 'expanded' : ''}`}>
                                {children}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ExpandableSection;